import { QueryClient } from '@tanstack/vue-query';

// Singleton QueryClient — нужен и в main.ts (плагин), и в auth.ts (clear при session_expired).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
  },
});
